import { useCallback, useState } from 'react';

import { EditorView, TextSelection, useReactNodeView } from '@lyearn/lygo-core';
import { Input } from '@lyearn/ui';

export default function BlockTitleAndDescription() {
  const { node, view, updateAttrs, getPos } = useReactNodeView();
  const [title, setTitle] = useState(node?.attrs.title ?? '');
  const [description, setDescription] = useState(node?.attrs.description ?? '');

  interface UnselectNodeEvent extends React.FocusEvent<HTMLInputElement> {}

  function unselectNode(event: UnselectNodeEvent): void {
    if (!view) return;
    event.preventDefault();
    const { state, dispatch } = view;
    const { tr } = state;

    // Create a text selection at the current selection's "to" position
    const textSelection = TextSelection.create(tr.doc, tr.selection.to);

    // Dispatch the new selection
    dispatch(tr.setSelection(textSelection));
  }
  const onUpdateTitle = useCallback(() => {
    if (title != node?.attrs.title) {
      updateAttrs({ title });
    }
  }, [title, node?.attrs.title]);

  const onUpdateDescription = useCallback(() => {
    if (description != node?.attrs.description) {
      updateAttrs({ description: description });
    }
  }, [description, node?.attrs.description]);

  return (
    <>
      <Input
        className="h-[5rem]"
        placeholder="Add title"
        value={title}
        variant="heading-s"
        onBlur={onUpdateTitle}
        onChange={(e) => setTitle(e.target.value)}
        onFocus={unselectNode}
      />
      <Input
        className="h-[5rem]"
        placeholder="Add description"
        value={description}
        onBlur={onUpdateDescription}
        onChange={(e) => setDescription(e.target.value)}
        onFocus={unselectNode}
      />
    </>
  );
}
